module.exports = "<div class=\"list-table\"><mat-spinner *ngIf=\"loading\"></mat-spinner></div>\n"